export enum CustomFormType {
    INDIVIDUAL = 0,
    SUPERVISOR = 1
}